/**
 * UATLauncher.jsx
 *
 * Preview-only floating launcher that links to existing fixture routes so
 * operators can navigate to them without losing the embedded authenticated
 * session.  Renders nothing outside the approved Preview hostnames.
 *
 * Environment gate - EXACT-MATCH ALLOWLIST (mirrors PsbFixturePage.jsx):
 *   Only the three explicitly listed hostnames show the launcher.
 *   Set.has() is used - NOT string.includes() - so evil.preview.example.com
 *   is blocked even though it contains '.preview.'.
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';

// Exact-match allowlist - fails CLOSED for any unlisted hostname.
const PREVIEW_HOST_ALLOWLIST = new Set([
  'localhost',
  '127.0.0.1',
  'audit-variance-qa.preview.emergentagent.com',  // current live Preview
]);
const IS_PREVIEW =
  typeof window !== 'undefined' &&
  PREVIEW_HOST_ALLOWLIST.has(window.location.hostname);

export default function UATLauncher() {
  const [open, setOpen] = useState(false);

  if (!IS_PREVIEW) return null;

  return (
    <div
      style={{ position: 'fixed', bottom: '1rem', left: '1rem', zIndex: 9999 }}
      data-testid="uat-launcher-root"
    >
      {open && (
        <div
          style={{
            background: '#1c1917',
            border: '1px solid #f97316',
            borderRadius: '0.5rem',
            padding: '0.75rem 1rem',
            marginBottom: '0.5rem',
            minWidth: '220px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.45)',
          }}
          data-testid="uat-launcher-panel"
        >
          <p style={{ color: '#fb923c', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.05em', marginBottom: '0.5rem' }}>
            PREVIEW UAT TOOLS
          </p>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            <li>
              <Link
                to="/dev/uat/bb-fixture"
                onClick={() => setOpen(false)}
                data-testid="uat-link-bb-fixture"
                style={{ color: '#fdba74', fontSize: '0.8rem', textDecoration: 'none' }}
              >
                Block Booking Fixture
              </Link>
            </li>
            <li>
              <Link
                to="/stocktaking/psb-stage1b-fixture"
                onClick={() => setOpen(false)}
                data-testid="uat-link-wave1-fixture"
                style={{ color: '#fdba74', fontSize: '0.8rem', textDecoration: 'none' }}
              >
                Wave 1 Reapply Fixture
              </Link>
            </li>
          </ul>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="uat-launcher-toggle"
        style={{
          background: open ? '#9a3412' : '#1c1917',
          border: '1px solid #f97316',
          borderRadius: '0.375rem',
          color: '#fb923c',
          fontSize: '0.7rem',
          fontWeight: 700,
          letterSpacing: '0.05em',
          padding: '0.3rem 0.6rem',
          cursor: 'pointer',
        }}
        title={open ? 'Close UAT launcher' : 'Open UAT launcher (Preview only)'}
      >
        {open ? '✕ UAT' : '⚑ UAT'}
      </button>
    </div>
  );
}
